var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs1"},[_vm._v(" 暂定标签0 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }